import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  announcementDate: 'field_announcement_date',
})
export default class Serializer extends NodeContentApiSerializer {}
